import { useState } from "react";

import {
  ExpandedState,
  getCoreRowModel,
  getExpandedRowModel,
  getFilteredRowModel,
  Table,
  useReactTable,
} from "@tanstack/react-table";

import { PROJECT_ISSUE_COLUMNS } from "../components/table/columns";
import { ProjectIssueWithChildren } from "../types";

interface ProjectIssueTableProps {
  /** Project Issue data has nested children */
  data: ProjectIssueWithChildren[];

  firstRowId: string | null;
}

/** Hook to create a TanStack table instance with the project issues. */
export function useProjectIssuesTable({
  data,
  firstRowId,
}: ProjectIssueTableProps) {
  const [rowSelection, setRowSelection] = useState({});
  const [expanded, setExpanded] = useState<ExpandedState>(() => {
    return firstRowId ? { [firstRowId]: true } : {};
  });

  return useReactTable<ProjectIssueWithChildren>({
    data,
    state: {
      rowSelection,
      expanded,
    },
    initialState: {
      expanded: true,
    },
    filterFns: {},
    sortingFns: {},
    getRowId: (row) => row.id,
    columns: PROJECT_ISSUE_COLUMNS,
    getCoreRowModel: getCoreRowModel(),
    getSubRows: (row) => row.children,
    getFilteredRowModel: getFilteredRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
    onExpandedChange: setExpanded,
    enableRowSelection: true,
    enableSubRowSelection: true,
    enableMultiRowSelection: true,
    onRowSelectionChange: setRowSelection,
    filterFromLeafRows: true,
    maxLeafRowFilterDepth: 1,
  });
}

export type ProjectIssuesTable = Table<ProjectIssueWithChildren>;
